export const SURVEY_TYPE = {
  VIRTUAL: 'VIRTUAL',
  ONSITE: 'ONSITE',
} as const;
